import { render, staticRenderFns } from "./PartialInfoGoodsDetail.vue?vue&type=template&id=1c93ce42&"
import script from "./PartialInfoGoodsDetail.vue?vue&type=script&lang=ts&"
export * from "./PartialInfoGoodsDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports